import script from "./GetStartedQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./GetStartedQuestion.vue?vue&type=script&setup=true&lang=js"

import "./GetStartedQuestion.vue?vue&type=style&index=0&id=cb679d54&lang=scss&scoped=true"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb679d54"]])

export default __exports__